import classNames from 'classnames';

type HashClass = string;
type Classes = {
    [bemClass: string]: HashClass,
};

export const hashedClasses = (moduleClasses: Classes): Classes => {
    const target = Object.keys(moduleClasses).reduce((acc, key) => {
        acc[key] = `${key} ${moduleClasses[key]}`;
        return acc;
    }, {} as Record<string, string>);
    const fallback = {
        get(targetObj: Classes, prop: string) {
            return targetObj[prop] ?? prop;
        },
    } as const;
    return new Proxy(target, fallback);
};

export const withCssModule = (moduleClasses: Classes) => {
    const hashed = hashedClasses(moduleClasses);

    return (...bemClasses: unknown[]): string =>
        classNames(bemClasses)
            .split(' ')
            .map((className: string) => hashed[className])
            .join(' ');
};
